import { getRoles } from '@/api/role';

export let companyAllActiveRoles: IRole.IResponse.IRoleInfo[] = [];

export const getCompanyAllActiveRoles = () => {
  return new Promise((resolve, reject) => {
    getRoles({
      active: true,
    }).then((res) => {
      companyAllActiveRoles = res.data;
      resolve(res.message);
    }).catch((err) => {
      reject(err.message);
    });
  });
};
